module.exports = __webpack_public_path__ + "img/RCaravan64_ua.d4edef33.webp";